import { render, staticRenderFns } from "./groupedTable.vue?vue&type=template&id=1020c091&"
import script from "./groupedTable.vue?vue&type=script&lang=js&"
export * from "./groupedTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports